<oui-layout [logoUrl]="logoUrl" [menu]="menu" [menuType]="'internal'">
  <oui-header *ngIf="displayHeader" [userMenu]="userMenu" [userName]="userName" logoLink="">
    <oui-header-actions>
      <oui-nav-button iconPrefix="help_outline" (click)="onHelpClick()">Aide en ligne</oui-nav-button>
    </oui-header-actions>
  </oui-header>

  <oui-content-layout>
    <router-outlet> </router-outlet>

    <ng-template #documentViewerPortalContent>
      <lib-document-viewer-panel></lib-document-viewer-panel>
    </ng-template>
  </oui-content-layout>
</oui-layout>
<div *ngIf="loadingService.isloadingSubject | async" class="loader">
  <oui-loading class="center"></oui-loading>
</div>
